import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, Renderer2, ViewChild, inject } from '@angular/core';

@Component({
    selector: 'ms-split-header',
    templateUrl: './split-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgTemplateOutlet],
})
export class SplitHeaderComponent {
    private renderer = inject(Renderer2);

    @HostBinding('class.scroll-container') @Input() enableScroll: boolean;
    @ViewChild('scrollWrapper', { read: ElementRef, static: false }) scrollWrapper: ElementRef;

    scrollToTop() {
        if (this.scrollWrapper?.nativeElement) {
            this.renderer.setProperty(this.scrollWrapper.nativeElement, 'scrollTop', 0);
        }
    }
}
